import React from "react";
import { Box, Paper, Typography, Stack, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const listCardSx = {
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  p: { xs: 2, md: 3 },
  borderRadius: 3,
  border: "1px solid",
  borderColor: "divider",
  boxShadow: "none",
  bgcolor: "background.paper",
};

export const formCardSx = {
  ...listCardSx,
  overflow: "visible",
  p: { xs: 2.5, md: 4 },
};

export const modalSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const modalPaperSx = {
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  bgcolor: "background.paper",
  borderRadius: 3,
  minWidth: { xs: "90vw", sm: 420 },
  maxWidth: 560,
  boxShadow: 8,
};

export const modalHeaderSx = {
  bgcolor: "primary.main",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  px: 3,
  py: 2,
};

export const dataTableCustomStyles = {
  table: {
    style: {
      backgroundColor: "transparent",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#f3f6f6",
      borderBottom: "1px solid rgba(0,0,0,0.08)",
      minHeight: "48px",
    },
  },
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: "12px",
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      color: "#5a6b6a",
    },
  },
  rows: {
    style: {
      minHeight: "52px",
      "&:hover": {
        backgroundColor: "rgba(0, 186, 178, 0.04)",
      },
    },
  },
  pagination: {
    style: {
      borderTop: "1px solid rgba(0,0,0,0.06)",
    },
  },
};

export function ListPageCard({ children, sx = {} }) {
  return (
    <Paper elevation={0} sx={{ ...listCardSx, ...sx }}>
      {children}
    </Paper>
  );
}

export function ListPageHeader({ title, actions, subtitle }) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", sm: "center" }}
      spacing={1.5}
      sx={{ mb: 2 }}
    >
      <Box>
        <Typography variant="h6" fontWeight={700} component="h2">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {actions}
        </Stack>
      )}
    </Stack>
  );
}

export function ListPageShell({ children }) {
  return <Box sx={{ width: "100%" }}>{children}</Box>;
}

export function FormPageShell({ children }) {
  return <Box sx={{ width: "100%" }}>{children}</Box>;
}

export function FormPageCard({ children, sx = {}, component = "div" }) {
  return (
    <Paper
      elevation={0}
      component={component}
      sx={{ ...formCardSx, ...sx }}
    >
      {children}
    </Paper>
  );
}

export function FormPageHeader({ title, onBack, subtitle }) {
  return (
    <Box sx={{ mb: 3 }}>
      {onBack && (
        <IconButton
          onClick={onBack}
          aria-label="back"
          sx={{ color: "primary.main", p: 0, mb: 1.5 }}
        >
          <ArrowBackIcon />
        </IconButton>
      )}
      {title && (
        <Typography variant="h6" fontWeight={700} component="h2">
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}

export function FormActions({ children }) {
  return (
    <Stack
      direction="row"
      spacing={1.5}
      justifyContent="flex-end"
      sx={{ mt: 3 }}
    >
      {children}
    </Stack>
  );
}

export function DeleteModalFrame({ title, children }) {
  return (
    <Box sx={modalPaperSx}>
      <Box sx={modalHeaderSx}>
        <Typography align="center" sx={{ color: "#fff", fontWeight: 700 }}>
          {title}
        </Typography>
      </Box>
      <Box sx={{ px: 3, py: 2 }}>{children}</Box>
    </Box>
  );
}
